import { Link } from "react-router-dom";

export function Monogram({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="8" fill="#26282E" />
      <rect x="1.5" y="1.5" width="61" height="61" rx="7" fill="none" stroke="#8FB0D4" strokeOpacity="0.7" strokeWidth="1.5" />
      <text x="32" y="41" textAnchor="middle" fontFamily="Fraunces, Georgia, serif" fontWeight="600" fontSize="26" fill="#8FB0D4" letterSpacing="1">CP</text>
    </svg>
  );
}

export default function Logo() {
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group">
      <Monogram />
      <span className="leading-none">
        <span className="block font-serif text-lg tracking-[0.14em] text-[#26282E] group-hover:text-[#2F5D8C] transition-colors duration-300">
          CREDIBLE PRESENCE
        </span>
        <span className="block mt-1 font-mono text-[10px] uppercase tracking-[0.28em] text-[#5B5E66]">
          Executive Voice &amp; Communication
        </span>
      </span>
    </Link>
  );
}
